export default __webpack_public_path__ + "a1e07fbec83b2277879c2e6059ab7cae.png";